import * as React from "react";
import ProgressBar from "src/share/components/ProgressBar/ProgressBar";

const GSLoading = ({ uploaded, total, percentage }) => {
  return (
    <div className="geosearch-loading">
      <div className="geosearch-loading__progress">
      <h5>We are performing facial recognition on the images recovered by our provider. It could take a few minutes.</h5>
        <ProgressBar percentage={percentage} />
        <p>
          {percentage}% ({uploaded} of {total} images)
        </p>
      </div>
    </div>
  );
};

export default GSLoading;
